// Configs
import config from "../../config";

// Services
import auth from "../auth/auth";
import request from "../request/request";
import FileConnector from "../fileConnector";

class backendConnector {
	async getAuthHeaders() {
		const defaultHeaders = {};
		if (auth.isAuth()) {
			defaultHeaders["Authorization"] = `Bearer ${auth?.getTokens()?.access_token}`;
		}
		return defaultHeaders;
	}

	async extendSession(data) {
		const authHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authentication/refresh_token",
			baseURL: config.BACKEND_URL,
			headers: { ...authHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async authenticate(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authorization/authenticate",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async forgotPassword(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authorization/forgot_password",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async reset_password(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authorization/reset_password",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async validateToken(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authorization/validate_reset_password_token",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async signUp(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/authorization/signup",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("Authantication Failed: ", err);
				return err;
			});
	}

	async constructQuestionnaire(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/construct_questionnaire",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("constructQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async submitAnswer(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/submit_answer",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("submitAnswer backend connector error: ", err);
				return err;
			});
	}

	async initiateQuestionnaire(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/initiate_questionnaire",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("initiateQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async initiateResult(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/initiate_result",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("initiateQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async updateQuestionnaire(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/update_questionnaire",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("updateQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async getSubmissionData(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/get_submission_data",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("initiateQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async submitQuestionnaire(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/submit_questionnaire",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("initiateQuestionnaire backend connector error: ", err);
				return err;
			});
	}

	async deleteSubmission(data) {
		const defaultHeaders = await this.getAuthHeaders();
		const requestConfig = {
			url: "/api/v1/questionnaire/delete_submission",
			baseURL: config.BACKEND_URL,
			headers: { ...defaultHeaders },
			data: data,
		};
		return request
			.post(requestConfig)
			.then((res) => res)
			.catch((err) => {
				console.log("deleteQuestion backend connector error: ", err);
				return err;
			});
	}

	downloadSubmissionDataExcel = async (data) => {
		return FileConnector.downloadFilesPost({
			url: "/questionnaire/download_submission_data_exact",
			data: data,
			responseType: "blob",
		}).then((res) => {
			if (res?.error) {
				return res;
			}

			const contentDisposition = res?.headers["content-disposition"];
			let fileName = "MENA FCCG ABC Self Assessment Questionnaire.xlsx";
			if (data?.language) {
				fileName = "استبيان التقييم الذاتي لـ MENA FCCG ABC.xlsx";
			}
			if (contentDisposition) {
				const match = contentDisposition.match(/filename="(.+)"/);
				if (match && match[1]) fileName = match[1];
			}

			const blob = new Blob([res.data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});

			const url = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);

			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);

			return { message: "assessment.results.downloadSuccess" };
		});
	};
}

export default new backendConnector();
